(function () {
  function slugify(text) {
    return text
      .toLowerCase()
      .trim()
      .replace(/[^\w\s-]/g, '')
      .replace(/\s+/g, '-')
      .replace(/-+/g, '-');
  }

  function initArticleToc(section) {
    const content = section.querySelector('[data-article-content]');
    const tocWrap = section.querySelector('[data-article-toc]');
    const tocList = section.querySelector('[data-article-toc-list]');
    if (!content || !tocWrap || !tocList) return;

    tocList.innerHTML = '';

    const headings = content.querySelectorAll('h2');
    if (headings.length === 0) {
      tocWrap.hidden = true;
      return;
    }

    tocWrap.hidden = false;

    headings.forEach((heading, index) => {
      const text = heading.textContent.trim();
      if (!text) return;

      let id = heading.id;
      if (!id) {
        id = slugify(text) || `section-${index + 1}`;
        let uniqueId = id;
        let counter = 2;
        while (document.getElementById(uniqueId)) {
          uniqueId = `${id}-${counter}`;
          counter += 1;
        }
        heading.id = uniqueId;
        id = uniqueId;
      }

      const link = document.createElement('a');
      link.href = `#${id}`;
      link.className = 'main-article__toc-link';

      const title = document.createElement('span');
      title.className = 'main-article__toc-title';
      title.textContent = text;

      link.appendChild(title);
      tocList.appendChild(link);
    });

    if (tocList.children.length === 0) {
      tocWrap.hidden = true;
    }
  }

  function initMainArticle(root) {
    const section = root.matches('[data-main-article]') ? root : root.querySelector('[data-main-article]');
    if (!section || section.dataset.initialized === 'true') return;

    section.dataset.initialized = 'true';
    initArticleToc(section);
  }

  function initAll() {
    document.querySelectorAll('[data-main-article]').forEach(initMainArticle);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', (event) => {
    const section = event.target.querySelector('[data-main-article]');
    if (section) {
      section.dataset.initialized = 'false';
      initMainArticle(section);
    }
  });
})();
